import { z } from 'zod';
import { paginationFiltersSchema, sortFiltersSchema } from 'utils/schemas';

export const teamsFiltersSchema = z
  .object({
    isHidden: z.boolean().catch(false),
    teams: z.array(z.string()).catch([]),
    departments: z.array(z.string()).catch([]),
    search: z.string().catch(''),
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);
